module.exports = __webpack_public_path__ + "static/company_location-ec96440ef529d2b37d04ae06c332c280.png";